import AuthService from "../../services/auth.service";

export const auth = {
  namespaced: true,
  state: {
    status: {
      authenticated: false,
      authorized: false,
    },
    user: null,
    referrer: null
  },
  actions: {
    async login({commit}, user) {
      try {
        commit("loginSuccess", await AuthService.login(user));
      } catch (error) {
        commit("loginFailure");
        return Promise.reject(error);
      }
    },
    async logout({commit}) {
      AuthService.logout();
      commit("logout");
    },
    async register({commit}, user) {
      try {
        let response = await AuthService.register(user);
        commit("setRegisterSuccess");
        return response;
      } catch (error) {
        commit("setRegisterFailure");
        return Promise.reject(error);
      }
    },
    async resetRegisterResult({commit}) {
      commit("resetRegisterResult");
    },
    async authenticate({commit, state}) {
      try {
        // User info stored in Vuex or local storage
        let user = state.user || JSON.parse(localStorage.getItem('user'));

        // If the user was authenticated within one minute, skip authentication
        if (!user || !user.lastAuthenticated || !((new Date() - new Date(user.lastAuthenticated)) < 60000)) {
          await AuthService.authenticate();
        }

        commit('loginSuccess', user);
      } catch (error) {
        commit('loginFailure');
      }
    },
  },
  mutations: {
    loginSuccess(state, user) {
      user.lastAuthenticated = new Date();
      state.status.authenticated = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.authenticated = false;
      state.status.autorized = false;
      state.user = null;
    },
    logout(state) {
      state.status.authenticated = false;
      state.status.autorized = false;
      state.user = null;
    },
    setRegisterSuccess(state) {
      state.status.authenticated = false;
      state.status.autorized = false;
      state.user = null;
    },
    setRegisterFailure(state) {
      state.status.authenticated = false;
      state.status.autorized = false;
      state.user = null;
    },
    setReferrer(state, referrer) {
      state.referrer = referrer;
    },
    setUserProfile(state, profileInfo) {
      state.user.profileImg = profileInfo.profileImg;
      state.user.profileImgName = profileInfo.profileImgName;
      state.user.profileImgPath = profileInfo.profileImgPath;
      state.user.accessToken = (JSON.parse(localStorage.getItem('user'))).accessToken;
      localStorage.setItem('user', JSON.stringify(state.user));
    }
  },
  getters: {
    referrer(state) {
      return state.referrer;
    },
    currentUser(state) {
      return state.user;
    },
  },
};
